import posthog from './posthog'

/**
 * Initialize PostHog analytics integration with TanStack Router.
 * Captures pageview events on every route change for SPA navigation.
 * 
 * @param {Router} router - TanStack Router instance
 */
export function initRouterAnalytics(router) {
    // Subscribe to router state changes to capture pageviews on navigation
    router.subscribe('onResolved', ({ toLocation }) => {
        // Capture pageview with the current path
        // PostHog will automatically include user properties if identified
        posthog.capture('$pageview', {
            $current_url: window.location.href,
            $pathname: toLocation.pathname,
            $host: window.location.host,
        })

        if (process.env.NODE_ENV === 'development') {
            console.log('[Router Analytics] Pageview captured:', toLocation.pathname)
        }
    })

    if (process.env.NODE_ENV === 'development') {
        console.log('[Router Analytics] Initialized')
    }
}
